<template>
    <div id="build-sample" style="padding: 8px; background: rgb(255, 255, 255);">
        <div id="___ytsubscribe_6"
             style="text-indent: 0px; margin: 0px; padding: 0px; background: transparent; border-style: none; float: none; line-height: normal; font-size: 1px; vertical-align: baseline; display: inline-block; width: 143px; height: 48px;">
            <iframe ng-non-bindable="" frameborder="0" hspace="0" marginheight="0" marginwidth="0" scrolling="no"
                    style="position: static; top: 0px; width: 143px; margin: 0px; border-style: none; left: 0px; visibility: visible; height: 48px;"
                    tabindex="0" vspace="0" width="100%" id="I9_1591129739262" name="I9_1591129739262"
                    src="https://www.youtube.com/subscribe_embed?usegapi=1&amp;channelid=UCHeRnkORi2B3G4kbSyhBtqA&amp;layout=full&amp;count=hidden&amp;origin=https%3A%2F%2Fdevelopers-dot-devsite-v2-prod.appspot.com&amp;gsrc=3p&amp;ic=1&amp;jsh=m%3B%2F_%2Fscs%2Fapps-static%2F_%2Fjs%2Fk%3Doz.gapi.en.utl9jrRztb8.O%2Fam%3DwQE%2Fd%3D1%2Fct%3Dzgms%2Frs%3DAGLTcCOUgIiKp6EMsn7UOgLQFm23i5pjzQ%2Fm%3D__features__#_methods=onPlusOne%2C_ready%2C_close%2C_open%2C_resizeMe%2C_renderstart%2Concircled%2Cdrefresh%2Cerefresh&amp;id=I9_1591129739262&amp;_gfid=I9_1591129739262&amp;parent=https%3A%2F%2Fdevelopers-dot-devsite-v2-prod.appspot.com&amp;pfname=&amp;rpctoken=96241053"
                    data-gapiattached="true"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        name: "YouTubeButton"
    }
</script>

<style scoped>

</style>